<template lang="html">
  <div class="phone-container">
    <div class="phone">
      <div class="screen">
        <div class="info">
          <img src="../assets/img/logo/small.png" class="logo">
          <div class="text">
            <slot />
          </div>
        </div>
        <img :src="require(`../assets/img/screenshots/phone/${image}`)" class="screenshot">
      </div>
      <img src="../assets/img/Phone-placeholder.png" class="placeholder">
    </div>
    <div class="text outside">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: "screenshot.png"
    }
  }
}
</script>

<style lang="css" scoped>
  @media screen and (max-width: 800px) {
    .phone-container {
      /* width: 90%; */
      /* margin-top: 80px; */
      transform: scale(0.9);
    }
    .phone {
    }
    .info {
      display: none;
      /* top: 105%; */
    }
    .text {
      width: 100%;
      font-size: 18px;
      line-height: 120%;
      text-align: left;
    }
    .outside {
      width: 100%;
      position: static;
      display:block;
      white-space: normal;
    }
    .text h2, .text h1, .text h1 * {
      font-size: 1em;
      display: inline;
    }
    .text h1:after {
      content: ' ';
      display: inline;
    }
    .text p {
      display: inline;
    }
    .text ul li {
      display: inline;
    }
    .text ul li:after {
      content: ', '
    }
    .text ul li:last-child:after {
      content: '.'
    }
    .logo {
      display: none;
    }
  }
  @media screen and (min-width: 800px) {
    .phone-container {
      /* width: 300px; */
      transform: scale(0.85);
    }
    .outside { display:none }
    .phone-container:hover {
      transform: scale(1);
    }
    .phone-container:hover .screenshot {
      opacity: 0;
      /* -webkit-filter: grayscale(0%);
      filter: grayscale(0%); */
    }
    .phone-container:hover .info {
      /* display: block; */
      opacity: 1;
    }
    .text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 80%;
      font-size: 24px;
      text-align: left;
      /* font-size: 24px; */
    }
    .text h1 {
      font-weight: 200;
      color: blue;
      font-size: 120px;
      margin: 0;
      padding: 0;
    }
    .text h2 {
      font-size: 42px;
      text-align: center;
    }
    .text h1 small {
      font-weight: 200;
      margin: 0;
      padding: 0;
    }
    .info {
      opacity: 0;
      padding: 5%;
      padding-top: 15%;
      top: 0;
      height: 100%;
      width: 100%;
    }
  }

  @media screen and (min-width: 800px), and (max-width: 1024px) {
    .text {
      font-size: 16px;
    }
  }

  @media screen and (min-width: 1024px), and (max-width: 1250px) {
    .text {
      font-size: 18px;
    }
  }

  /* @media screen and (min-width: 1200px), and (max-width: 1250px) {
    .text {
      font-size: 24px;
    }
  } */

  @media screen and (min-width: 1300px), and (max-width: 1600px) {
    .text {
      font-size: 18px;
    }
  }

  @media screen and (min-width: 1600px) {
    .text {
      font-size: 26px;
    }
  }

  .phone-container {
    /* width: 300px; */
    transition: .3s;
  }

  .phone {
    position: relative;
  }
  .screen {
    height: 94%;
    width: 87%;
    top: 2%;
    left: 5.5%;
    border-radius: 5%;
    background-color: #0d0d0e;
    position: absolute;
  }
  .screenshot, .info {
    width: 100%;
    /* border-radius: 10%; */

    transition: .3s;
  }
  .screenshot {
    position: relative;
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
  }
  .info {
    position: absolute;
  }
  .text {
    color: white;
  }
  .text ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .logo {
    text-align: center;
    margin: auto;
  }
  .placeholder {
    position: relative;
    width: 100%;
  }
</style>
